import A11yDialog from "a11y-dialog";
import { setCookie } from "../utils/helpers.js";

/**
 * Initialize a11y-dialog instances
 */
export function initDialogs() {
	// Make A11yDialog globally available
	window.A11yDialog = A11yDialog;

	// Handle popup dialogs with delay
	const popupDialogs = document.querySelectorAll("[data-dialog-delay]");

	popupDialogs.forEach((dialogElement) => {
		const dialogDelay = dialogElement.dataset.dialogDelay;
		const dialogId = dialogElement.dataset.dialogId;
		const cookieName = "STYXKEY-popup-" + dialogId;

		// Check if dialog was already dismissed
		if (document.cookie.indexOf(cookieName) !== -1) {
			return;
		}

		// Create dialog instance
		const dialog = new A11yDialog(dialogElement);

		// Set cookie when dialog is closed
		dialog.on("hide", function () {
			setCookie(cookieName, true);
		});

		// Show dialog after delay, during an idle period for better UX
		const delay = parseInt(dialogDelay) * 1000;
		setTimeout(() => {
			// Wait for browser idle time before showing popup
			// This prevents interrupting animations or user interactions
			if (window.requestIdleCallback) {
				requestIdleCallback(
					() => {
						dialog.show();
					},
					{ timeout: 1000 } // Show within 1s even if browser stays busy
				);
			} else {
				// Fallback for browsers without requestIdleCallback support
				dialog.show();
			}
		}, delay);
	});
}
